<div class="plugins-dialog-container">
  <div class="title-container" style="display: flex; justify-content: space-between; align-items: center">
    <span id="backup-page-title">
      {{ backupTimestamp | date }} -
      {{ 'PAGES.BACKUPS.PLUGINS_MODAL.TITLE' | translate }}
    </span>
    <button mat-icon-button tabindex="-1" class="dismiss-dialog-button" color="accent" (click)="closeDialog()">
      <mat-icon>clear</mat-icon>
    </button>
  </div>

  <div class="plugins-information-container">
    <mat-table id="plugins-list" #table [dataSource]="dataSource">
      <ng-container matColumnDef="plugins">
        <mat-header-cell *matHeaderCellDef>
          {{ 'PAGES.BACKUPS.PLUGINS_MODAL.TABLE.PLUGINS' | translate }}
        </mat-header-cell>
        <mat-cell class="plugins-column" *matCellDef="let plugin">
          <div>
            <span class="plugins-name">
              {{ plugin.name }}
            </span>
            <span class="plugins-version">{{ plugin.version }} ({{ plugin.status }})</span>
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="changes">
        <mat-header-cell class="changes-header" *matHeaderCellDef>
          {{ 'PAGES.BACKUPS.PLUGINS_MODAL.TABLE.CHANGES' | translate }}
        </mat-header-cell>
        <mat-cell class="changes-column" *matCellDef="let plugin">
          @if (checkPluginDiff(plugin)) {
            @for (chip of pluginChip; track chip) {
              <mat-chip-option class="plugins-chip" [disabled]="true">
                {{ chip }}
              </mat-chip-option>
            }
          }
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>
  <button mat-raised-button class="short-button close-button" type="submit" color="accent" (click)="closeDialog()">
    {{ 'PAGES.BACKUPS.PLUGINS_MODAL.BUTTONS.CLOSE' | translate }}
  </button>
</div>
